import request from "@/config/utils/request";

// 附件预览 文件地址解密
export function getFileUrlSecret(data) {
  return request({
    url: "/apis/bid/oss/getFileUrlSecret",
    method: "post",
    data
  });
}
// 附件预览新接口
export function filePreview(data) {
  return request({
    url: "/apis/bid/oss/filePreview",
    method: "post",
    data
  });
}
